import styled from 'styled-components';
import { colors, toRgba, breakPoints } from '@/styles';

export const DataGrid = styled.div<{ $revalidating: boolean }>`
  flex: 1;

  opacity: ${({ $revalidating }) => ($revalidating ? 0.35 : 1)};
  /* font-family: var(--font-family-mono); */
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue',
    sans-serif;
  font-feature-settings: 'tnum';
  font-variant-numeric: tabular-nums;

  .rightPane.split-view-view {
    &::before {
      z-index: 0 !important;
    }
  }

  .rightPane,
  .leftPane {
    /* transition: all 0.15s ease-in-out; */
    /* will-change: width; */
    overflow: visible !important;

    @media (max-width: ${breakPoints.mobile}) {
      display: none;
    }
  }

  .dataPane {
    @media (max-width: ${breakPoints.mobile}) {
      width: 100% !important;
      left: 0 !important;
      right: 0 !important;
    }
  }

  .rdg-cell {
    border-color: ${colors.secondary.lightGray2};
    overflow: hidden;
  }

  /* Make room for sorting arrows */
  .rdg-header-row .rdg-cell {
    padding-inline: 8px 16px;
  }

  .header-cell {
    font-size: 13px;
  }
  .image-cell {
    display: flex;
    height: 100%;
    padding: 4px;
    & > * {
      display: flex;
    }
  }
  .text-cell {
    font-size: 13px;
    overflow: hidden;
  }
  .header-cell-right {
    text-align: right;
  }
  .header-cell-added {
    color: ${colors.semantic.positive.dark};
    background-color: ${colors.semantic.positive.light};
  }
  .header-cell-removed {
    color: ${colors.semantic.negative.dark};
    background-color: ${colors.semantic.negative.light};
    /* text-decoration: line-through; */
  }
  .header-cell-modified {
    color: ${colors.semantic.diff.modified.indicator};
    background-color: ${colors.semantic.diff.modified.background};
  }

  .text-cell {
    text-overflow: ellipsis;
    /* white-space: break-spaces; */
    overflow-y: auto;
    font-feature-settings: 'tnum';
    font-variant-numeric: tabular-nums;
    span {
      padding: 2px 5px;
      border-radius: 3px;
    }
  }

  div:has(> .row-added) {
    /* background-color: ${colors.semantic.diff.added.background}; */
    background-color: ${toRgba(colors.semantic.diff.added.indicator, 0.15)};
    color: ${colors.semantic.diff.added.indicator};
  }
  div:has(> .row-removed) {
    /* background-color: ${colors.semantic.diff.removed.background}; */
    background: ${toRgba(colors.semantic.diff.removed.indicator, 0.1)};
    color: ${colors.semantic.diff.removed.indicator};
  }
  div:has(> .row-modified) {
    &:has(> .text-cell-compare-added) span {
      background: ${toRgba(colors.semantic.diff.added.indicator, 0.15)};
    }
    &:has(> .text-cell-compare-removed) span {
      background: ${toRgba(colors.semantic.diff.removed.indicator, 0.1)};
    }
  }

  div:has(> .row-dirty) {
    background: ${toRgba(colors.semantic.diff.modified.indicator, 0.1)};
    /* &:has(> .text-cell-compare-added) span {
      background: ${toRgba(colors.semantic.diff.added.indicator, 0.15)};
    }
    &:has(> .text-cell-compare-removed) span {
      background: ${toRgba(colors.semantic.diff.removed.indicator, 0.1)};
    } */
  }

  div:has(> .text-cell-added) {
    background-color: ${colors.semantic.positive.light};
  }

  div:has(> .text-cell-removed) {
    background-color: ${colors.semantic.negative.light};
  }

  div:has(> .text-cell-match) {
    color: ${colors.semantic.positive.primary};
  }
  div:has(> .text-cell-mismatch) {
    color: ${colors.semantic.negative.primary};
  }
  div:has(> .text-cell-compare) {
  }
  div:has(> .text-cell-compare-unchanged) {
  }
  div:has(> .text-cell-compare-added) {
    color: ${colors.semantic.diff.added.indicator};
    background-color: ${toRgba(colors.semantic.diff.added.indicator, 0.1)};
  }
  div:has(> .text-cell-compare-removed) {
    color: ${colors.semantic.diff.removed.indicator};
  }
  div:has(> .text-cell-editable) {
    position: relative;
    &:after {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 5px 5px 0;
      border-color: transparent ${colors.semantic.positive.primary} transparent transparent;
      right: 0;
      top: 0;
      position: absolute;
    }
  }
  div:has(> .text-cell-not-editable) {
    position: relative;
    &:after {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 5px 5px 0;
      border-color: transparent ${colors.semantic.negative.primary} transparent transparent;
      right: 0;
      top: 0;
      position: absolute;
    }
  }
`;

export const GridPane = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
